export default Object.freeze({
  HOME_CARD_07_DAYS_TEXT: 'Past Week',
  HOME_CARD_30_DAYS_TEXT: 'Past 30 Days',
  HOME_CARD_90_DAYS_TEXT: 'Past 90 Days',
  HOME_CARD_TOTAL_TEXT: 'Total',
  HOME_CARD_TITLE: 'Updated Records',
  HOME_CARD_TITLE_TOTAL_TEXT: 'Total Records',
});
